module.exports = __webpack_public_path__ + "img/EFTOT.ef9cea48.svg";